import AdminAdminTeamPage from '../../../components/admin/settings/AdminAdminTeamPage'

export default function SettingsAdminTeam() {
  return <AdminAdminTeamPage />
}
